<template>
  <div class="coderpix_tm_section" id="about">
    <div class="section_inner">
      <div class="coderpix_tm_about">
        <div class="left">
          <div class="image">
            <img src="img/thumbs/1-1.jpg" alt="" />
            <div class="main" data-img-url="img/about/1.jpg"></div>
          </div>
        </div>
        <div class="right">
          <div class="short">
            <h3 class="name">Okan <span class="coloring">Şahin</span></h3>
            <h3 class="job">
              <AnimationText />
            </h3>
          </div>
          <div class="text">
            <p>
              Modern web teknolojileri konusunda tutkulu bir geliştiriciyim. <span>Next.js</span>, <span>React</span>, <span>Vue.js</span> ile özel siteler kodluyor, <span>WordPress</span> ve <span>Shopify</span>'da tema çözümleri sunuyorum. <span>N8N</span> otomasyonları ve <span>yapay zeka</span> entegrasyonlarıyla projelerinizi geleceğe taşıyorum.
            </p>
          </div>
          <div class="coderpix_tm_button" id="aboutPopup">
            <a href="#">Daha Fazla</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimationText from "./AnimationText.vue";
export default {
  name: `AboutComponent`,
  data() {
    return {
      open: false,
    };
  },
  components: {
    AnimationText,
  },
};
</script>

<style scoped>
.coderpix_tm_modalbox {
  top: -90px;
}
</style>


